import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
// import Button from '@mui/material/Button';
import logo from "./LC-Logo_optimiert.svg"
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
// import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Stack from '@mui/material/Stack';

import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import CopyrightRoundedIcon from '@mui/icons-material/CopyrightRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
// import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import SupportRoundedIcon from '@mui/icons-material/SupportRounded';
// import LocalCafeRoundedIcon from '@mui/icons-material/LocalCafeRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';

export const LCAppBar = (props) => {
  // console.log('ResponsiveAppBar-entered',props);


  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  
  const { handleOpenPage } = props;
  const title = 'Linux-Café Stuttgart';

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
    const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  const handleNavClicked = (name) => {
    handleCloseNavMenu();
    handleOpenPage({ main: name });
  }

  const tasks = [
    // { name: 'welcome', text: "Start", Icon: () => (<HomeRoundedIcon />),  profile: 0},
    { name: 'aboutLC', text: "Über Uns", Icon: () => (<PeopleRoundedIcon />),  profile: 0 },
    { name: 'events', text: "Termine", Icon: () => (<CalendarMonthRoundedIcon />),  profile: 0 },
    { name: 'contact', text: "Kontakt", Icon: () => (<EmailRoundedIcon />),  profile: 0 },
    { name: 'downloads', text: "Dokumente", Icon: () => (<MenuBookRoundedIcon />),  profile: 0 },
    { name: 'links', text: "Links", Icon: () => (<LinkRoundedIcon />),  profile: 0 },
    { name: 'manuals', text: "Support", Icon: () => (<SupportRoundedIcon />),  profile: 1 },
    { name: 'legalNotice', text: "Rechtliches", Icon: () => (<CopyrightRoundedIcon />),  profile: 0 },
  ]

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#B0B0B0" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-start' }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Stack direction='row' alignItems='center' justifyContent='center'>
              <Typography
                variant="h6"
                noWrap
                component="div"
                style={{ color: "#0F0F0F" }}
                sx={{ mr: 2, display: 'flex' }}
                onClick={() => handleNavClicked("welcome")}
              >
                <b>{title}</b>
              </Typography>
              <img src={logo} width="50" alt={"Tux - Linux-Cafe Stuttgart"} onClick={() => handleNavClicked("welcome")} />
            </Stack>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: 'block',
              }}
            >
              {tasks.filter((t) => window.profile >= t.profile).map(({ name, text, Icon }) => {
                return (
                  <MenuItem key={name} onClick={() => handleNavClicked(name)}>
                    <ListItemIcon><Icon size="small" /></ListItemIcon>
                    <ListItemText>{text}</ListItemText>
                  </MenuItem>
                )
              })}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <Stack direction='row' alignItems='center' justifyContent='center'>
              <Typography
                variant="h6"
                noWrap
                component="div"
                style={{ color: "#0F0F0F" }}
                sx={{ mr: 2, display: 'flex' }}
                onClick={() => handleNavClicked("welcome")}
              >
                <b>{title}</b>
              </Typography>
              <img src={logo} width="50" alt={"Tux - Linux-Cafe Stuttgart"} onClick={() => handleNavClicked("welcome")} />
            </Stack>

            {tasks.filter((t) =>   window.profile >= t.profile).map(({ name, text}) => {
              return (
                <Button key={'b' + name} onClick={() => handleNavClicked(name)}
                  sx={{ my: 2, color: 'black', display: 'block',textTransform: 'capitalize' }} > {text} </Button>

              )
            })}
          </Box>
                    <Box sx={{ flexGrow: 0 }}>
            <Stack direction="row" alignItems="center">
              <IconButton onClick={handleOpenUserMenu} sx={{ my: 2, color: 'black', display: 'block' }}>
                <MoreVertRoundedIcon />
              </IconButton>
            </Stack>
            <Menu sx={{ mt: '45px' }} id="menu-appbar-user" anchorEl={anchorElUser}
              anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
              keepMounted transformOrigin={{ vertical: 'top', horizontal: 'right', }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem key="profile" onClick={() => {window.profile = window.profile === 0 ?  1 : 0 ; handleCloseUserMenu()}}>
                <ListItemIcon><SupportRoundedIcon /></ListItemIcon>
              </MenuItem>
            </Menu>

          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

